/* ============
 * Mutations for the account module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import Vue from 'vue'
import { STORE, UPDATE, CHECK, UNLOAD, SET_COMPREHENSIVE_PRIVACY_NOTICE, SET_CONFIDENTIALITY_DATA_PROCESSING_LETTER, SET_POLICY_WHATSAPP_BUSINESS } from './mutation-types'

export default {
  [CHECK](state) {
    let accountData = Vue.$storage.getItem('account')
    accountData = accountData ? JSON.parse(atob(accountData)) : null
    state.accountLoaded = accountData
  },

  [UNLOAD](state) {
    state.accountLoaded = null
  },
  [SET_COMPREHENSIVE_PRIVACY_NOTICE](state) {
    state.comprehensivePrivacyNotice = true
  },

  [SET_CONFIDENTIALITY_DATA_PROCESSING_LETTER](state) {
    state.confidentialityDataProcessingLetter = true
  },

  [SET_POLICY_WHATSAPP_BUSINESS](state) {
    state.policyWhatsappBusiness = true
  },

  [STORE](state, account) {
    state.userId = account.userId
    state.username = account.username
    state.treatment = account.treatment
    state.firstName = account.firstName
    state.lastName = account.lastName
    state.secondLastName = account.secondLastName
    state.email = account.email
    // Profile information
    state.profileId = account.profileId
    state.avatar = account.avatar
    state.phone = account.phone
    state.phoneExt = account.phoneExt
    state.cellphone = account.cellphone
    state.client = account.client
    // Groups and permissions
    state.groups = account.groups
    state.permissions = account.permissions
    state.userPermissions = account.userPermissions
    state.provider = account.provider
    state.comprehensivePrivacyNotice = account.comprehensivePrivacyNotice
    state.confidentialityDataProcessingLetter = account.confidentialityDataProcessingLetter
    state.policyWhatsappBusiness = account.policyWhatsappBusiness
  },

  [UPDATE](state, account) {
    state.userId = account.userId
    state.username = account.username
    state.treatment = account.treatment
    state.firstName = account.firstName
    state.lastName = account.lastName
    state.secondLastName = account.secondLastName
    state.email = account.email
    // Profile information
    state.profileId = account.profileId
    state.avatar = account.avatar
    state.phone = account.phone
    state.phoneExt = account.phoneExt
    state.cellphone = account.cellphone
    // Groups and permissions
    state.groups = account.groups
    state.permissions = account.permissions
    state.userPermissions = account.userPermissions
    state.provider = account.provider
    state.comprehensivePrivacyNotice = account.comprehensivePrivacyNotice
    state.confidentialityDataProcessingLetter = account.confidentialityDataProcessingLetter
    state.policyWhatsappBusiness = account.policyWhatsappBusiness
  }
}
